import { IconProps } from '.';

function Lamp({ style, className }: IconProps) {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 25 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      style={style}
      className={className}
    >
      <title>Lamp</title>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M12.4796 4C9.68759 4 7.4128 6.0614 7.04713 8.63894C6.83728 10.2294 7.33483 11.7971 8.40825 12.988C9.16897 13.8118 9.59138 14.9133 9.59138 16.058L9.59053 16.6238C9.59008 16.6326 9.58984 16.6415 9.58984 16.6504C9.58984 16.6588 9.59005 16.6672 9.59046 16.6755L9.58841 18.0462C9.58841 19.1298 10.4683 20 11.5517 20H13.4449C14.5269 20 15.4073 19.1293 15.4073 18.047L15.4112 16.059C15.4112 14.8659 15.7991 13.8101 16.5064 13.0787C17.474 12.0787 18 10.7717 18 9.4C17.9957 6.41378 15.5042 4 12.4796 4ZM10.5784 17.1504L10.5771 18.047C10.5771 18.5723 11.0095 19 11.5523 19H13.4455C13.9868 19 14.4198 18.5718 14.4198 18.046L14.4215 17.1504H10.5784ZM14.4235 16.1504L14.4237 16.058C14.4237 14.6148 14.9045 13.3062 15.8009 12.3792C16.5876 11.5661 17.0125 10.5104 17.0125 9.40074C17.009 6.97661 14.9688 5 12.4802 5C10.1866 5 8.32255 6.68917 8.02645 8.77617C7.85627 10.0661 8.26039 11.3395 9.13477 12.3096C10.0639 13.3156 10.5801 14.6618 10.5801 16.0588L10.5799 16.1504H14.4235Z'
        fill='currentColor'
      />
    </svg>
  );
}

export default Lamp;
